import PropTypes from 'prop-types'
import React from 'react'
import { Link } from 'react-router-dom'
import { TruncatedTextWithTooltip } from '../../molecules/TruncatedTextWithTooltip'
import UserInfoTable from '../forms/UserInfoTable'
import Table from '../../atoms/table/Table'
import Tr from '../../atoms/table/Tr'
import Th from '../../atoms/table/Th'
import Td from '../../atoms/table/Td'
import { requestCountText } from '../../../utils/helpers'

const CollaboratorTable = ({ enabledProcedureManagements = [] }) => {
  return (
    <div className="pt-8 pb-2">
      <Table
        className="table-fixed lg:w-full"
        values={enabledProcedureManagements}
        head={
          <Tr body={false}>
            <Th className="w-4">ID</Th>
            <Th>Nombre</Th>
            <Th className="w-52">Habilitación</Th>
            <Th className="w-52">Actualización</Th>
            <Th className="w-44">Publicación</Th>
            <Th className="w-44">Solicitudes</Th>
          </Tr>
        }
        body={enabledProcedureManagements.map(row => (
          <Tr key={row.id}>
            <Td td>{row.id}</Td>
            <Td>
              <TruncatedTextWithTooltip text={row.name}>
                {props => (
                  <Link to={`gestiones-de-tramites-habilitadas/${row.id}/vista-previa`} {...props}>
                    {row.name}
                  </Link>
                )}
              </TruncatedTextWithTooltip>
            </Td>
            <Td>
              <UserInfoTable
                date={row.created_at}
                name={row.creator_name}
                eliminatorName={row.creator_eliminator_name}
                eliminatedName={row.eliminated_creator_name}
              />
            </Td>
            <Td>
              <UserInfoTable
                date={row.updated_at}
                name={row.updater_name}
                eliminatorName={row.updater_eliminator_name}
                eliminatedName={row.eliminated_updater_name}
              />
            </Td>
            <Td>{row.published ? 'Publicado' : 'No publicado'}</Td>
            <Td>
              <Link to={`/gestiones-de-tramites-habilitadas/${row.id}/solicitudes`}>
                {requestCountText(row.procedures_count)}
              </Link>
            </Td>
          </Tr>
        ))}
      />
    </div>
  )
}

export default CollaboratorTable

CollaboratorTable.propTypes = {
  enabledProcedureManagements: PropTypes.arrayOf(PropTypes.object)
}
